module.exports = {"1":"入力が空です。","2":"板に収まらない部材があります。"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/jsons/nesting_errors.json
// module id = o+Bp
// module chunks = 1